<template>
    <div>
        <svg :width="iconSize" :height="iconSize" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd"
                d="M20.783 1.72005C20.9787 1.86767 21.0937 2.09861 21.0937 2.34376V6.23275C21.094 6.24454 21.094 6.25631 21.0937 6.26804V16.9821C21.0937 18.3774 20.1688 19.6036 18.8273 19.9869L17.4523 20.3797C15.7535 20.8651 14.0625 19.5896 14.0625 17.8228C14.0625 16.6355 14.8496 15.5921 15.9912 15.2659L18.398 14.5782C19.0688 14.3866 19.5312 13.7735 19.5312 13.0759V7.28573L10.1562 9.9643V20.1071C10.1562 21.5024 9.23132 22.7286 7.88975 23.1119L6.51477 23.5047C4.81601 23.9901 3.125 22.7146 3.125 20.9478C3.125 19.7605 3.91207 18.7171 5.05368 18.3909L7.4605 17.7032C8.13128 17.5116 8.59375 16.8985 8.59375 16.2009V9.39228C8.59348 9.38048 8.59348 9.3687 8.59375 9.35696V5.46876C8.59375 5.11994 8.82498 4.81339 9.16037 4.71757L20.0979 1.59257C20.3336 1.52522 20.5872 1.57242 20.783 1.72005Z"
                :fill="color" 
            />
        </svg>
    </div>
</template>

<script>
export default {
    name: 'IconSvgMusic',
    props: {
        color: {
            type: String,
            default: '#000000',
        },
        size: {
            type: Number,
            default: null
        }
    },
    computed: {
        iconSize() {
            return this.size ? `${this.size}px` : '44px'
        }
    }
};
</script>

<style scoped></style>